import React from "react";
import { SearchResultsEmptyLoaderTemplate } from "themes/administration/device-menu/components";

function SearchResultsEmptyLoader(props) {
    return <SearchResultsEmptyLoaderTemplate {...props} />;
}

export default SearchResultsEmptyLoader;
